export const GET_SYSTEMS = "GET_SYSTEMS";
export const GET_SYSTEMS_ERROR = "GET_SYSTEMS_ERROR";
export const GET_SYSTEMS_SUCCESS = "GET_SYSTEMS_SUCCESS";

export const GET_SYSTEM_COMPONENTS_RANGE = "GET_SYSTEM_COMPONENTS_RANGE";
export const GET_SYSTEM_COMPONENTS_RANGE_SUCCESS = "GET_SYSTEM_COMPONENTS_RANGE_SUCCESS";
export const GET_SYSTEM_COMPONENTS_RANGE_ERROR = "GET_SYSTEM_COMPONENTS_RANGE_ERROR";

export const SLICE_NAME = "systems";